import type { Sticker } from '../types';

export const fruits: Sticker[] = [
  {
    id: 12001,
    url: 'https://stickers.nauczniaczek.pl/colections/13462217-fruits/png/001-girl.png',
    name: 'Dziewczynka z Owocami',
    category: 'fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 12002,
    url: 'https://stickers.nauczniaczek.pl/colections/13462217-fruits/png/002-fruits.png',
    name: 'Koszyk Owoców',
    category: 'fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 12003,
    url: 'https://stickers.nauczniaczek.pl/colections/13462217-fruits/png/003-girl.png',
    name: 'Dziewczynka z Jabłkiem',
    category: 'fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 12004,
    url: 'https://stickers.nauczniaczek.pl/colections/13462217-fruits/png/004-boy.png',
    name: 'Chłopiec z Gruszką',
    category: 'fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 12005,
    url: 'https://stickers.nauczniaczek.pl/colections/13462217-fruits/png/005-fruit.png',
    name: 'Świeże Owoce',
    category: 'fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 12006,
    url: 'https://stickers.nauczniaczek.pl/colections/13462217-fruits/png/006-girl.png',
    name: 'Dziewczynka z Bananem',
    category: 'fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 12007,
    url: 'https://stickers.nauczniaczek.pl/colections/13462217-fruits/png/007-girl.png',
    name: 'Dziewczynka z Pomarańczą',
    category: 'fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 12008,
    url: 'https://stickers.nauczniaczek.pl/colections/13462217-fruits/png/008-boy.png',
    name: 'Chłopiec z Arbuzem',
    category: 'fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 12009,
    url: 'https://stickers.nauczniaczek.pl/colections/13462217-fruits/png/009-fruits.png',
    name: 'Miska Owoców',
    category: 'fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 12010,
    url: 'https://stickers.nauczniaczek.pl/colections/13462217-fruits/png/010-girl.png',
    name: 'Dziewczynka z Truskawką',
    category: 'fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 12011,
    url: 'https://stickers.nauczniaczek.pl/colections/13462217-fruits/png/011-apple.png',
    name: 'Czerwone Jabłko',
    category: 'fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 12012,
    url: 'https://stickers.nauczniaczek.pl/colections/13462217-fruits/png/012-girl.png',
    name: 'Dziewczynka z Winogronem',
    category: 'fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 12013,
    url: 'https://stickers.nauczniaczek.pl/colections/13462217-fruits/png/013-boy.png',
    name: 'Chłopiec z Ananasem',
    category: 'fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 12014,
    url: 'https://stickers.nauczniaczek.pl/colections/13462217-fruits/png/014-girl.png',
    name: 'Dziewczynka z Mango',
    category: 'fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 12015,
    url: 'https://stickers.nauczniaczek.pl/colections/13462217-fruits/png/015-boy.png',
    name: 'Chłopiec z Kiwi',
    category: 'fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 12016,
    url: 'https://stickers.nauczniaczek.pl/colections/13462217-fruits/png/016-girl.png',
    name: 'Dziewczynka z Malinami',
    category: 'fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 12017,
    url: 'https://stickers.nauczniaczek.pl/colections/13462217-fruits/png/017-girl.png',
    name: 'Dziewczynka z Borówkami',
    category: 'fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 12018,
    url: 'https://stickers.nauczniaczek.pl/colections/13462217-fruits/png/018-apple.png',
    name: 'Zielone Jabłko',
    category: 'fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 12019,
    url: 'https://stickers.nauczniaczek.pl/colections/13462217-fruits/png/019-girl.png',
    name: 'Dziewczynka z Cytryną',
    category: 'fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 12020,
    url: 'https://stickers.nauczniaczek.pl/colections/13462217-fruits/png/020-boy.png',
    name: 'Chłopiec z Mandarynką',
    category: 'fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  }
];